{
  "form": {
    "coApplicant": {
      "label": "Onko lainalla yhteishakija?",
      "error": "Tarkista yhteishakija"
    },
    "primaryIncome": {
      "label": "Kuukausitulosi verojen jälkeen",
      "error": "Tarkista kuukausitulosi",
      "tooltip": "Sinun säännölliset kuukausitulosi verojen jälkeen, esim. palkka, eläke tai elatusmaksut. Älä huomioi tässä epäsäännölllisiä tuloja, kuten bonuksia tai ylityölisiä."
    },
    "secondaryIncome": {
      "label": "Yhteishakijan kuukausitulot verojen jälkeen",
      "error": "Tarkista yhteishakija kuukausitulot"
    },
    "maritalStatus": {
      "label": "Mikä on siviilisäätysi?",
      "error": "Tarkista siviilisääty",
      "tooltip": "Jos muutat yhteen toiseen henkilön kanssa, valitse \"Avoliitto\". Jos olet eronnut, muuttamassa uuteen asuntoon avioeron tai asumuseron takia, valitse \"Naimaton\".",
      "options": {
        "cohabitant": "Avoliitto",
        "married": "Avioliitto tai rekisteröity parisuhde",
        "single": "Naimaton",
        "widow": "Leski"
      }
    },
    "children": {
      "label": "Kuinka monta lasta asuu kotitaloudessasi?",
      "error": "Tarkista lasten määrä"
    },
    "cars": {
      "label": "Kuinka monta autoa on kotitaloudessasi?",
      "error": "Tarkista autojen määrä",
      "tooltip": "Vapaata autoetua ei lasketa mukaan."
    },
    "followingQuestion": {
      "label": "Onko sinulla joitakin seuraavista?",
      "tooltip": {
        "properties": [
          {
            "introText": "Vaihtoehto"
          },
          {
            "categoryName": "Asunnot"
          },
          {
            "categoryDescription": "kattaa asunto-osakkeet tai kiinteistöt, esim. sijoitus-tai vapaa-ajanasunto, jonka aiot pitää ja johon sinulla on lainaa."
          }
        ],
        "otherLoans": [
          {
            "introText": "Vaihtoehto"
          },
          {
            "categoryName": "Muu laina"
          },
          {
            "categoryDescription": "kattaa kertaluontoiset kulutuslainat, esimerkiksi auton ostamista, remonttia, lomaa tai yleisiä elinkustannuksia varten otetut lainat."
          }
        ],
        "credit": [
          {
            "introText": "Vaihtoehto"
          },
          {
            "categoryName": "Luotto/luottokortti"
          },
          {
            "categoryDescription": "kattaa jatkuvat kulutusluotot ja luottorajalliset luottokortit."
          }
        ]
      }
    },
    "propertiesToSell": {
      "label": "Asunnot, joita et aio myydä"
    },
    "loansRemainingBalance": {
      "label": "Jäljellä oleva asuntolainan määrä",
      "error": "Tarkista asuntolainan määrä",
      "tooltip": "Jäljelle jäävä kokonaislainamäärä kaikkiin asuntoihin, joita et aio myydä"
    },
    "housingCompanyDebt": {
      "label": "Asunto-osakkeen yhtiölainan jäljelle jäävä lainanmäärä",
      "error": "Tarkista yhtiölainan määrä",
      "tooltip": "Jäljelle jäävä yhtiölainan kokonaismäärä kaikkiin asuntoihin, joita et aio myydä. Syötä \"0\", jos aiot maksaa pois taloyhtiölainan uudella lainalla tai jos asunto-osakkeeseen ei kohdistu yhtiölainaa."
    },
    "otherLoans": {
      "label": "Muut lainat"
    },
    "personalLoansBalance": {
      "label": "Jäljelle oleva muihin lainoihin kohdistuva lainanmäärä",
      "error": "Tarkista lainanmäärä",
      "tooltip": "Muu lainat kattaa kertaluontoiset kulutuslainat, esimerkiksi auton ostamista, remonttia, lomaa tai yleisiä elinkustannuksia varten otetut lainat."
    },
    "creditCards": {
      "label": "Luotot/luottokortit"
    },
    "creditCardsLimit": {
      "label": "Luottoraja",
      "error": "Tarkista luottoraja",
      "tooltip": "Suurin luottomäärä, joka sinulla voi kerrallaan olla. Jos esimerkiksi luottorajasi on {{creditLimit}} ja olet käyttänyt siitä {{usedAmount}}, syötä tähän kenttään {{creditLimit}}."
    },
    "submit": "Laske"
  },
  "loading": "Ladataan...",
  "yes": "Kyllä",
  "no": "Ei",
  "help": "auttaa",
  "years": "vuotta",
  "button": {
    "applyForLoan": "Hae lainaa"
  },
  "tips": {
    "heading": "Vinkkejä asuntolainalaskurin käyttöön",
    "subHeading": "Täyttämällä laskurin tiedot mahdollisimman täsmällisesti saat pikaisen arvion siitä, kuinka paljon voisit saada Danske Bankista lainaa. Voit myös kokeilla, miten erilaiset valinnat vaikuttavat arvioituun lainamäärään ja lainan kuukausierään."
  },
  "results": {
    "preliminaryBorrow": {
      "heading": "Voit alustavasti saada lainaa",
      "subHeading": "Lähetä meille hakemus saadaksesi selville tarkan lainamäärän ja lisätietoja lainasta. Se on ilmaista eikä sido sinua mihinkään.",
      "link": "https://danskebank.fi/lainat/hakemus/"
    },
    "donutChart": {
      "heading": "Esimerkkilaskema lainan kuukausittaisista kuluista",
      "monthlyInstallment": "Kuukausierä",
      "amortization": {
        "label": "Lyhennys",
        "tooltip": "Lyhennykset tarkoittavat lainasi takaisinmaksussa osaa, joka kohdistuu lainan saldon pienentämiseen."
      },
      "interestPayment": {
        "label": "Koron maksu"
      },
      "loanAmount": {
        "label": "Lainamäärä"
      },
      "maturity": {
        "label": "Laina-aika",
        "tooltip": {
          "text": "Asuntolainan takaisinmaksuaika on yleensä 20-30 vuotta. Voit tutkia eri takaisinmaksuaikoja, korkoja ja lyhennystapoja kululaskurillamme.",
          "link": "Siirry kululaskuriin",
          "url": "https://danskebank.fi/sinulle/tyokalut/asuntolainalaskuri"
        }
      },
      "interestRate": {
        "label": "Korko",
        "tooltip": {
          "label": "Lainan esimerkkikorko on laskettu {{date}} korkotiedoilla. Korko voi nousta tai laskea. Voit tutkia eri takaisinmaksuaikoja, korkoja ja lyhennystapoja meidän kululaskurillamme.",
          "link": "Siirry kululaskuriin"
        }
      }
    },
    "loanAdjust": {
      "heading": "Muuta lainamäärää",
      "subHeading": "Arvioi lainan erilaiset kuukausittaiset kustannukset",
      "label": "To Be Confirmed..."
    },
    "footer": {
      "label": "Voit tutkia lisää eri takaisinmaksuaikoja, korkoja ja lyhennystapoja meidän kululaskurillamme.",
      "ctaButton": "Siirry kululaskuriin"
    },
    "error": {
      "heading": "Voi ei, lainalaskuri epäonnistui",
      "subHeading": "Yritä uudelleen. Jos ongelma jatkuu, olethan yhteydessä meihin 0200 2580 (mpm/pvm)."
    }
  },
  "moreInformation": {
    "heading": "Lisätietoja",
    "howWeCalculate": {
      "title": "Miten me laskemme",
      "paragraph1": "Olemme arvioineet takaisinmaksukykysi antamiesi tietojen perusteella. Takaisinmaksukykysi vaikuttaa siihen, kuinka paljon voit saada lainaa. Laskelman arvio perustuu tilastollisiin elinkustannuksiin. Lainan takaisinmaksussa olemme huomioineet viitekoron mahdolliset nousut.",
      "paragraph2": "Laskelma ei huomioi omarahoitusosuutta tai lainalle tarvittavaa vakuutta. Omien säästöjen ja lisävakuuden tarve on noin 20-30 % kohteen kauppahinnasta ja ostettava kohde toimii ensisijaisena vakuutena."
    },
    "thingsToConsider": {
      "title": "Muita huomioitavia asioita",
      "paragraph1": "Lainan saamiseen vaikuttaa maksukyvyn lisäksi myös lainaan tarvittavat vakuudet. Ostettava asunto käy vakuudeksi asuntolainalle isoissa kaupungeissa enimmillään 70-80 %:lle asunnon velattomasta kauppahinnasta.",
      "paragraph2": "Ensiasuntoon myönnettävän lainan määrä voi olla enintään 95 % ostettavan asunnon velattomasta kauppahinnasta. Ensiasunnon ostajalla on siis oltava vähintään 5 % omia säästöjä tai muita vakuuksia. Useimmiten lainan lisävakuutena käytetään maksullista vakuutusyhtiön lainatakausta, valtion tarjoamaa maksullista lisätakausta tai esimerkiksi vanhempien asuntoa tai muuta omaisuutta.",
      "paragraph3": {
        "mortgageInfo": "Jos asuntolaina on sinulle ajankohtainen, täytä ",
        "loanApplication": "lainahakemus",
        "followUp": " hyvissä ajoin. Saat asiasi sujuvasti käsittelyyn ja alustavan vastauksen nopeasti sähköpostiisi tai verkkopankkiisi.",
        "loanApplicationUrl": "https://danskebank.fi/lainat/hakemus"
      }
    }
  },
  "legalText": {
    "paragraph1": "Lainan myöntäminen edellyttää aina hyväksyttyä luottopäätöstä. Luottopäätöksen tekemistä varten Danske Bank tarkistaa asiakkaan henkilöluottotiedot Suomen Asiakastieto Oy:stä. Tämän lisäksi luottohakemuksen käsittelemistä varten voimme hakea ja käsitellä tietojasi Positiivisesta luottotietorekisteristä. Lainan korko ja muut ehdot tarkentuvat lainatarjouksessa. Pyydä oma tarjouksesi Danske Bankista.",
    "paragraph2": "Esimerkki asuntolainasta: Jos asiakas ottaa 170 000 euron asuntolainan, jossa laina-aika olisi 25 vuotta ja lainan viitekorkona käytetään 12 kk euribor-korkoa, lainan kokonaiskorko olisi 4,278 % (Kuluttajansuojalain mukaan laskettu todellinen vuosikorko 4,452 %). Luoton ja muiden luottokustannusten yhteismäärä on 280 765,04 euroa, sis. järjestelypalkkion 1 020 euroa ja automaattisen tiliveloituksen maksun 2,70 euroa/maksuerä. Maksuerien lukumäärä on 300 kpl. Esimerkki laskettu 25.07.2024 korkotiedoilla."
  }
}
